export default __webpack_public_path__ + "static/media/logo-standard.8ed0df99.svg";